jQuery(document).ready(function($) {

  $('.menu-toggler').click(function(event) {
    //event.preventDefault();
    $('.menu-toggler').toggleClass('is-active');
    $('.handheld-header__nav-wrapper').toggleClass('is-opened'); //ouverture du menu
    $('header.site-header').toggleClass('menu-is-opened');

  });

  $('.handheld-header__nav li.menu-item-has-children').append('<span class="icon-chevron"></span>');

  $('.handheld-header__nav li.menu-item-has-children span.icon-chevron').click(function(event) {
    $(this).parent('li').toggleClass('is-opened');

  });

  /*if(window.matchMedia("(max-width: 991px)").matches) {

    $('.navigation-link').click(function(event) {

      if( $(this).siblings().length > 0 ){
        event.preventDefault();
        $(this).toggleClass('opened');
        //$(this).next('.mega-navigation').toggleClass('active');
      }

    });
};*/

});
